import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { useTaskContext } from "../context/TaskContext";
import Swal from "sweetalert2";

const customStyles2 = {
  content: {
    top: "50%",
    left: "50%",
    width: "50%",
    maxWidth: "400px",
    maxHeight: "80%",
    transform: "translate(-50%, -50%)",
    overflowY: "auto",
    padding: "15px 40px 40px 40px",
    borderRadius: "10px",
    border: "none",
    background: "#ffffff",
    position: "relative",
    boxShadow: "0 10px 50px rgba(0, 0, 0, 0.2)",
    fontFamily: "Inter, sans-serif",
    "::WebkitScrollbar": {
      width: "0px",
      background: "transparent",
    },
    /* Ocultar scrollbar en IE y Edge */
    msOverflowStyle: "none",
    /* Ocultar scrollbar en Firefox */
    scrollbarWidth: "none",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 1008,
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "16px",
    color: "#333",
    marginBottom: "5px",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    borderRadius: "4px",
    border: "1px solid #E5E7EB",
    boxSizing: "border-box",
    background: "#F8FAFB",
  },
  inputColor: {
    appearance: "none",
    border: "1px solid #E5E7EB",
    height: "42px",
    width: "100%",
    borderRadius: "4px",
    cursor: "pointer",
    padding: "0",
    transition: "box-shadow 0.3s ease",
    marginTop: "10px",
  },
  addButton: {
    padding: "12px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#007bff",
    color: "#ffffff",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
  },
};

const CreateListModal = ({
  isOpen,
  onRequestClose,
  listToEdit,
  projectId,
  ownerUid,
}) => {
  const { createOrUpdateList } = useTaskContext();

  const [newListName, setNewListName] = useState("");
  const [selectedColor, setSelectedColor] = useState("#1e63ff");
  const inputRef = useRef(null);

  /* --------------------------------------------------------- */
  /*  Efectos                                                  */
  /* --------------------------------------------------------- */
  useEffect(() => {
    if (listToEdit) {
      setNewListName(listToEdit.name);
      setSelectedColor(listToEdit.color || "#1e63ff");
    } else {
      setNewListName("");
      setSelectedColor("#1e63ff");
    }
  }, [listToEdit, isOpen]);

  useEffect(() => {
    if (isOpen && inputRef.current) inputRef.current.focus();
  }, [isOpen]);

  /* --------------------------------------------------------- */
  /*  Helpers                                                  */
  /* --------------------------------------------------------- */
  const resetForm = () => {
    setNewListName("");
    setSelectedColor("#1e63ff");
  };

  const handleClose = () => {
    resetForm();
    onRequestClose();
  };

  /* --------------------------------------------------------- */
  /*  Guardar / Actualizar                                     */
  /* --------------------------------------------------------- */
  const handleAddOrUpdateList = async () => {
    /* 1. Validaciones básicas */
    if (!newListName.trim()) {
      return Swal.fire(
        "El nombre de la lista no puede estar vacío",
        "",
        "warning"
      );
    }

    /* 2. Intento de crear / editar */
    const ok = await createOrUpdateList({
      name: newListName.trim(),
      color: selectedColor,
      projectId: projectId || null,
      ownerUid,
      oldName: listToEdit?.name || null,
    });

    /* 3. Si todo fue bien, cerramos el modal */
    if (ok) handleClose();
  };

  /* --------------------------------------------------------- */
  /*  Render                                                   */
  /* --------------------------------------------------------- */
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={customStyles2}
      contentLabel={listToEdit ? "Editar Lista" : "Agregar Lista"}
    >
      <div
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 15,
        }}
      >
        <h2 style={{ textAlign: "center", color: "#44566C" }}>
          {listToEdit ? "Editar Lista" : "Agregar Lista"}
        </h2>

        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#EAEDF0",
            color: "#44566C",
            borderRadius: "50%",
            height: 32,
            width: 32,
            border: "none",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            lineHeight: 0,
            fontSize: 16,
          }}
          aria-label="Cerrar modal"
        >
          <i className="bi bi-x-lg" />
        </button>
      </div>

      <div style={customStyles2.inputContainer}>
        <label style={customStyles2.label}>
          Nombre de la Lista:
          <input
            ref={inputRef}
            type="text"
            style={customStyles2.input}
            placeholder="Escribe el nombre de la lista"
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
          />
        </label>

        <label style={customStyles2.label}>
          Color:
          <input
            type="color"
            style={customStyles2.inputColor}
            value={selectedColor}
            onChange={(e) => setSelectedColor(e.target.value)}
          />
        </label>
      </div>

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button onClick={handleAddOrUpdateList} style={customStyles2.addButton}>
          {listToEdit ? "Actualizar Lista" : "Guardar Lista"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateListModal;
